import {countrySelectorBuilder} from "./countrySelector";
import {intlTelInputBuilder} from "../intlTelInput/intlTelInput";


/**
 * Añade el comportamiento para que muestre un lightbox al usuario reconsiderando que marque la casilla de mail-publi
 * @param {jQuery} mailingCommercial input que representa la aceptación del usuario a recibir correos con publi
 */
export const reconsiderAdvertising = (mailingCommercial) => {
    console.log('Cargado');
    const form = mailingCommercial.closest('form');
    const lightbox = lity();
    let lightboxShowed = false;



    $('#terceraOpcionModal').on('click', '.form-button', function(e) {
        e.preventDefault();
        lightbox.close();
        if ($(this).prop('id') === 'terceraOpcionModalOK') {
            mailingCommercial.prop('checked', 'checked');
            form.find('button[type="submit"]').trigger('click');
        }
        form.find('button[type="submit"]').trigger('click');
    });

    form.on('submit', function(e){
        if (!mailingCommercial.is(':checked') && !lightboxShowed) {
            lightbox('#terceraOpcionModal');
            lightboxShowed = true;
            return false;
        }

        form.find('button[type="submit"]').children() .text('Enviando');
        return true;
    });
}

/**
 * Añade el comportamiento para que al cambiar la forma de pago, recargue la información extra.
 * @param {jQuery} select Select que representa el select con las formas de pago
 */
export const paymentMethodChange = (select) => {
    const form = select.closest('form');
    select.on('change', function(){
        $.ajax({
            url: form.attr('action'),
            method: form.attr('method'),
            data: form.serialize(),
            success: function(html){
                $('#payment-method-extra-info').fadeOut('normal', function(){
                    $('#payment-method-extra-info').html($(html).find('#payment-method-extra-info'));
                    $('#payment-method-extra-info').fadeIn('normal');
                });
            }
        })
    });
}

export const changeUserDataSubscription = () => {
    $('#update-user-data').on('click', function() {
        $.ajax({
            url: $(this).data('url'),
            type: 'post',
            beforeSend: function() {
                $('#modal-datos-usuario .form').html('<div class="bigLoader"><div class="loader"></div>');
            },
            success: function (html) {
                $('#modal-datos-usuario .form').empty().html($(html));
                countrySelectorBuilder($('#ProfileUser_idCountry'));
                intlTelInputBuilder($('#ProfileUser_mobilePhone_tel'));
            }
        });
    });


    $('#modal-datos-usuario').on('submit', 'form', function(e) {
        e.preventDefault();

        var $form = $(this);
        var data  = $form.serializeArray()
        data.push( {'name': $('#ProfileUser_submit').attr('name')} );
        $.ajax({
            url:  $form.attr('action'),
            type: $form.attr('method'),
            data: data,
            beforeSend: function() {
                $('#modal-datos-usuario .form').html('<div class="bigLoader"><div class="loader"></div>');
            },
            success: function(data){
                if (data.success) {
                    $(".lity-close").trigger('click');
                    $('#user-data-info').replaceWith(
                        $(data.user_info).find('#user-data-info')
                    );
                } else {
                    $('#modal-datos-usuario .form').empty().html($(data));
                    countrySelectorBuilder($('#ProfileUser_idCountry'));
                    intlTelInputBuilder($('#ProfileUser_mobilePhone_tel'));
                }
            }
        });

        return false;
    });
}
